import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card, InputGroup } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { CONGBOTRENWEB_API } from '../../../../utils/apiUrl';
import { loaiDanhGiaValue } from '../../../../utils/define';
import moment from 'moment';

const FieldDisplay = ({ label, value }) => {
    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div>
                <span className="text-dark" style={{ fontSize: '15px', fontWeight: 600 }}>
                    {value !== null && value !== undefined && value !== '' ? value : <span className="text-muted font-italic" style={{ fontWeight: 'normal' }}>Chưa cập nhật</span>}
                </span>
            </div>
        </Form.Group>
    );
};

const CongBoTrenWebForm = ({ baoVeCapVienId, readOnly = false, isUserView = false, onDataLoaded, onSaveSuccess }) => {
    const [saving, setSaving] = useState(false);
    
    const [congBoTrenWebId, setCongBoTrenWebId] = useState(null);
    const [ketQua, setKetQua] = useState(loaiDanhGiaValue.dat);
    
    // Web cơ sở đào tạo
    const [isDongGopMoiCSDT, setIsDongGopMoiCSDT] = useState(true);
    const [ngayDangCSDT, setNgayDangCSDT] = useState('');
    const [truocSoNgayCSDT, setTruocSoNgayCSDT] = useState('');
    const [linkDangTaiWebCSDT, setLinkDangTaiWebCSDT] = useState('');

    // Web Bộ Giáo dục và Đào tạo
    const [isDongGopMoiGDDT, setIsDongGopMoiGDDT] = useState(true);
    const [ngayDangGDDT, setNgayDangGDDT] = useState('');
    const [truocSoNgayGDDT, setTruocSoNgayGDDT] = useState('');
    const [linkDangTaiWebGDDT, setLinkDangTaiWebGDDT] = useState('');

    const { data: queryRes, refetch, isLoading } = useQuery(
        ['congBoTrenWebData', baoVeCapVienId], 
        () => Get(`${CONGBOTRENWEB_API.GET_BY_BAOVECAPVIEN_ID}/${baoVeCapVienId}`),
        { 
            enabled: !!baoVeCapVienId,
            refetchOnWindowFocus: false 
        }
    );

    useEffect(() => {
        if (queryRes) {
            let item = null;
            if (Array.isArray(queryRes)) {
                item = queryRes[0];
            } else if (queryRes.data && Array.isArray(queryRes.data)) {
                item = queryRes.data[0];
            } else if (queryRes.data?.$values) {
                item = queryRes.data.$values[0];
            } else if (queryRes.data) {
                item = queryRes.data;
            } else {
                item = queryRes;
            }

            if (item && item.id) {
                setCongBoTrenWebId(item.id);
                setKetQua(item.ketQua || loaiDanhGiaValue.dat);
                
                setIsDongGopMoiCSDT(item.isDongGopMoiCSDT || false);
                setNgayDangCSDT(item.ngayDangCSDT ? moment(item.ngayDangCSDT).format('YYYY-MM-DD') : '');
                setTruocSoNgayCSDT(item.truocSoNgayCSDT || '');
                setLinkDangTaiWebCSDT(item.linkDangTaiWebCSDT || '');

                setIsDongGopMoiGDDT(item.isDongGopMoiGDDT || false);
                setNgayDangGDDT(item.ngayDangGDDT ? moment(item.ngayDangGDDT).format('YYYY-MM-DD') : '');
                setTruocSoNgayGDDT(item.truocSoNgayGDDT || '');
                setLinkDangTaiWebGDDT(item.linkDangTaiWebGDDT || '');
                
                if (onDataLoaded) onDataLoaded(true);
            } else {
                if (onDataLoaded) onDataLoaded(false);
            }
        } else if (queryRes === null) {
            if (onDataLoaded) onDataLoaded(false);
        }
    }, [queryRes]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                BaoVeCapVienId: baoVeCapVienId,
                KetQua: ketQua,
                
                IsDongGopMoiCSDT: isDongGopMoiCSDT,
                NgayDangCSDT: ngayDangCSDT || null,
                TruocSoNgayCSDT: truocSoNgayCSDT ? parseInt(truocSoNgayCSDT) : null,
                LinkDangTaiWebCSDT: linkDangTaiWebCSDT || '',

                IsDongGopMoiGDDT: isDongGopMoiGDDT,
                NgayDangGDDT: ngayDangGDDT || null,
                TruocSoNgayGDDT: truocSoNgayGDDT ? parseInt(truocSoNgayGDDT) : null,
                LinkDangTaiWebGDDT: linkDangTaiWebGDDT || ''
            };

            if (congBoTrenWebId) {
                await Put(CONGBOTRENWEB_API.UPDATE_ITEM, congBoTrenWebId, { ...payload, Id: congBoTrenWebId });
            } else {
                await Post(CONGBOTRENWEB_API.CREATE, null, payload);
            }

            toast.success('Lưu thông tin thành công!');
            await refetch();
            if (onSaveSuccess) onSaveSuccess();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded">
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">1. Thông tin chung</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Kết quả</>} value={ketQua === loaiDanhGiaValue.dat ? 'Đạt' : 'Không đạt'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Kết quả</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Đạt"
                                            name="ketQua"
                                            checked={ketQua === loaiDanhGiaValue.dat}
                                            onChange={() => setKetQua(loaiDanhGiaValue.dat)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không đạt"
                                            name="ketQua"
                                            checked={ketQua === loaiDanhGiaValue.khongDat}
                                            onChange={() => setKetQua(loaiDanhGiaValue.khongDat)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-success shadow-sm">
                <Card.Header className="bg-success text-white font-weight-bold">2. Web cơ sở đào tạo</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Luận án, tóm tắt luận án, trang thông tin những đóng góp mới</>} value={isDongGopMoiCSDT ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Luận án, tóm tắt luận án, trang thông tin những đóng góp mới</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isDongGopMoiCSDT"
                                            checked={isDongGopMoiCSDT === true}
                                            onChange={() => setIsDongGopMoiCSDT(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isDongGopMoiCSDT"
                                            checked={isDongGopMoiCSDT === false}
                                            onChange={() => setIsDongGopMoiCSDT(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">2.</span> Ngày đăng</>} value={ngayDangCSDT ? moment(ngayDangCSDT).format('DD/MM/YYYY') : ''} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Ngày đăng</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={ngayDangCSDT}
                                        onChange={(e) => setNgayDangCSDT(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">3.</span> Số ngày đăng trước ngày bảo vệ</>} value={truocSoNgayCSDT} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Số ngày đăng trước ngày bảo vệ</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={truocSoNgayCSDT}
                                        onChange={(e) => setTruocSoNgayCSDT(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số ngày..."
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <Form.Group className="mb-3">
                                    <Form.Label className="font-weight-bold"><span className="text-danger">4.</span> Link thông tin đăng tải</Form.Label>
                                    <div>
                                        {linkDangTaiWebCSDT ? (
                                            <a 
                                                href={linkDangTaiWebCSDT.startsWith('http') ? linkDangTaiWebCSDT : `http://${linkDangTaiWebCSDT}`} 
                                                target="_blank" 
                                                rel="noreferrer" 
                                                className="btn btn-outline-primary"
                                                title="Mở link đăng tải"
                                            >
                                                <i className="fas fa-external-link-alt mr-1"></i> Mở link: {linkDangTaiWebCSDT}
                                            </a>
                                        ) : (
                                            <span className="text-muted font-italic">Chưa cập nhật</span>
                                        )}
                                    </div>
                                </Form.Group>
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">4.</span> Link thông tin đăng tải</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            value={linkDangTaiWebCSDT}
                                            onChange={(e) => setLinkDangTaiWebCSDT(e.target.value)}
                                            placeholder="Nhập link đăng tải..."
                                        />
                                        {linkDangTaiWebCSDT && (
                                            <InputGroup.Append>
                                                <a 
                                                    href={linkDangTaiWebCSDT.startsWith('http') ? linkDangTaiWebCSDT : `http://${linkDangTaiWebCSDT}`} 
                                                    target="_blank" 
                                                    rel="noreferrer" 
                                                    className="btn btn-outline-primary"
                                                    title="Mở link đăng tải"
                                                >
                                                    <i className="fas fa-external-link-alt"></i>
                                                </a>
                                            </InputGroup.Append>
                                        )}
                                    </InputGroup>
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-warning shadow-sm">
                <Card.Header className="bg-warning text-white font-weight-bold">3. Web Bộ Giáo dục và Đào tạo</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">1.</span> Luận án, tóm tắt luận án, trang thông tin những đóng góp mới</>} value={isDongGopMoiGDDT ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Luận án, tóm tắt luận án, trang thông tin những đóng góp mới</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isDongGopMoiGDDT"
                                            checked={isDongGopMoiGDDT === true}
                                            onChange={() => setIsDongGopMoiGDDT(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isDongGopMoiGDDT"
                                            checked={isDongGopMoiGDDT === false}
                                            onChange={() => setIsDongGopMoiGDDT(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">2.</span> Ngày đăng</>} value={ngayDangGDDT ? moment(ngayDangGDDT).format('DD/MM/YYYY') : ''} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Ngày đăng</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={ngayDangGDDT}
                                        onChange={(e) => setNgayDangGDDT(e.target.value)}
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label={<><span className="text-danger">3.</span> Số ngày đăng trước ngày bảo vệ</>} value={truocSoNgayGDDT} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Số ngày đăng trước ngày bảo vệ</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={truocSoNgayGDDT}
                                        onChange={(e) => setTruocSoNgayGDDT(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số ngày..."
                                    />
                                </Form.Group>
                            )}
                        </Col>

                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <Form.Group className="mb-3">
                                    <Form.Label className="font-weight-bold"><span className="text-danger">4.</span> Link thông tin đăng tải</Form.Label>
                                    <div>
                                        {linkDangTaiWebGDDT ? (
                                            <a 
                                                href={linkDangTaiWebGDDT.startsWith('http') ? linkDangTaiWebGDDT : `http://${linkDangTaiWebGDDT}`} 
                                                target="_blank" 
                                                rel="noreferrer" 
                                                className="btn btn-outline-primary"
                                                title="Mở link đăng tải"
                                            >
                                                <i className="fas fa-external-link-alt mr-1"></i> Mở link: {linkDangTaiWebGDDT}
                                            </a>
                                        ) : (
                                            <span className="text-muted font-italic">Chưa cập nhật</span>
                                        )}
                                    </div>
                                </Form.Group>
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold"><span className="text-danger">4.</span> Link thông tin đăng tải</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            value={linkDangTaiWebGDDT}
                                            onChange={(e) => setLinkDangTaiWebGDDT(e.target.value)}
                                            placeholder="Nhập link đăng tải..."
                                        />
                                        {linkDangTaiWebGDDT && (
                                            <InputGroup.Append>
                                                <a 
                                                    href={linkDangTaiWebGDDT.startsWith('http') ? linkDangTaiWebGDDT : `http://${linkDangTaiWebGDDT}`} 
                                                    target="_blank" 
                                                    rel="noreferrer" 
                                                    className="btn btn-outline-primary"
                                                    title="Mở link đăng tải"
                                                >
                                                    <i className="fas fa-external-link-alt"></i>
                                                </a>
                                            </InputGroup.Append>
                                        )}
                                    </InputGroup>
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave()} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                </div>
            )}
        </div>
    );
};

export default CongBoTrenWebForm;
